import logNewRelicCustom from '../../../utils/logNewRelicCustom';
import { NEW_RELIC_EVENTS } from '../../../constants';

export const updateNonVisualizedQty = (set, get, sku, qty) => {
  const state = get();
  if (!state || !state.designs || !state.designs[state.selectedDesignId]) return;

  const cart = Array.isArray(state.designs[state.selectedDesignId].Cart)
    ? [...state.designs[state.selectedDesignId].Cart]
    : [];

  const idx = cart.findIndex((item) => String(item.Sku) === String(sku));
  if (idx === -1) return; // Item not found, nothing to update

  if (qty > 0) {
    cart[idx] = { ...cart[idx], Quantity: qty };
  } else {
    // If qty is 0 or less, remove the item
    cart.splice(idx, 1);
  }

  set({
    designs: {
      ...state.designs,
      [state.selectedDesignId]: {
        ...state.designs[state.selectedDesignId],
        Cart: cart,
      },
    },
  }, false, { type: 'UPDATE_NON_VISUALIZED_QTY', payload: { designId: state.selectedDesignId, sku, qty } });
};
